<script lang="ts">export let size = "20";
const height = size;
</script>

<svg
	{height}
	style="fill: currentColor"
	xmlns="http://www.w3.org/2000/svg"
	viewBox="0 0 25.71 28.35"
	><g
		><path
			d="M24.95 1.55c-.33-.25-.73-.38-1.14-.38-.18 0-.37.03-.55.08l-1.5.45c-.5.12-1.33.27-2.43.27-1.31 0-2.64-.21-3.95-.63-1.49-.48-3.06-.72-4.65-.72-.66 0-1.28.04-1.85.11v-.74H0v15.28h7.19c-.44.7-.86 1.45-1.25 2.25-1.08 2.21-1.88 4.78-1.97 7.59l-.11 3.22h14.73l.09-3.03c.02-.66.15-2.82.99-5.55s2.37-6.02 5.18-8.97l.86-.9v-6.8c0-.6-.28-1.17-.77-1.53Zm-1.02 7.63-.37.39c-3.04 3.2-4.7 6.75-5.59 9.68-.9 2.93-1.04 5.24-1.06 6.02l-.04 1.3H5.71l.05-1.38c.08-2.51.8-4.83 1.79-6.87s2.26-3.79 3.41-5.14l1.25-1.47H7.1v1.8H1.78V1.78h5.31v1.06l1.05-.19c.73-.14 1.61-.24 2.58-.24 1.41 0 2.79.21 4.11.63 1.48.47 3 .71 4.49.71 1.27 0 2.25-.17 2.87-.33h.02l1.55-.47h.03l.07.02.05.1v6.1Z"
		/><path
			d="M19.33 5.1c-1.63 0-3.28-.26-4.9-.78-1.18-.38-2.43-.57-3.7-.57-2.53 0-4.33.77-4.35.78l-.62.27V3.12H3.12v9.04h2.64v-1.8h10.1l-1.01.8c-.08.06-7.48 5.97-7.75 14.07h8.48c.06-1.99.7-9.93 7.02-16.58V4.72h-.01c-.68.17-1.8.38-3.25.38Z"
		/></g
	></svg
>
